import React from "react"

export function Context({ children }: { children: React.ReactNode }) {
    return <div className="mt-2 text-xs text-gray-600 italic">{children}</div>
}
